import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CustomCursor } from './CustomCursor';
import { Toaster } from '../ui/sonner';

export const Layout = ({ children, showFooter = true }) => {
    return (
        <div className="min-h-screen bg-background">
            {/* Noise overlay for texture */}
            <div className="noise-overlay" />
            
            {/* Custom cursor */}
            <CustomCursor />
            
            {/* Navigation */}
            <Navbar />
            
            {/* Main content */}
            <main>
                {children}
            </main>
            
            {/* Footer */}
            {showFooter && <Footer />}
            
            {/* Toast notifications */}
            <Toaster position="bottom-right" />
        </div>
    );
};
